import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {OrderUpsellBundleCtaComponent} from './order-upsell-bundle-cta.component';
import {MessageModule, ModalModule} from 'ng-design-system';
import {RouterModule} from '@angular/router';
import {OrderUpsellService} from '@app/product/services/order-upsell.service';

@NgModule({
  declarations: [
    OrderUpsellBundleCtaComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    MessageModule,
    ModalModule,
    RouterModule,
    ConfigModule.withConfig({
      cmsComponents: {
        OrderUpsellBundleCtaComponent: {
          component: OrderUpsellBundleCtaComponent,
        }
      }
    })
  ],
  providers: [
    OrderUpsellService,
  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA
  ],
  exports: [
    OrderUpsellBundleCtaComponent
  ]
})
export class OrderUpsellBundleCtaModule {
}
